import { yupResolver } from "@hookform/resolvers/yup";
import { CreateAction } from "@root/utils/enums/communication";
import { number, object, string } from "yup";
import { mailFormSchema } from "./emailModalContent/resolver";
import { smsFormSchema } from "./smsModalContent/resolver";

const notifyFormSchema = object({
  status: string().optional(),
  createAction: number()
    .oneOf(Object.values(CreateAction).filter((v) => typeof v === "number"))
    .optional()
    .default(CreateAction.NONE),
});

export const notifyByMailModalResolver = yupResolver(notifyFormSchema.concat(mailFormSchema));
export const notifyBySmsModalResolver = yupResolver(notifyFormSchema.concat(smsFormSchema));
